export const lightTheme = {
  background: '#bcb8b1',
  color: '#121212',
  accentColor: '#8a817c',
  chronoTheme: {
    cardBgColor: 'white',
    cardForeColor: 'black',
    titleColor: 'black',
  },
  timelineLineColor: '#ccc',
  cardBackground: '#fff',
  cardFooterBackground: '#f7f7f7',
  cardBorderColor: '#00000020',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'light',
  bsSecondaryVariant: 'dark',
  socialIconBgColor: '#121212',
};

export const darkTheme = {
  background: '#1d1b1a',
  color: '#eee',
  accentColor: '#e0afa0',
  chronoTheme: {
    cardBgColor: '#262220',
    cardForeColor: '#eee',
    titleColor: 'white',
  },
  timelineLineColor: '#444',
  cardBackground: '#262220',
  cardFooterBackground: '#2e2a27',
  cardBorderColor: '#ffffff20',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'dark',
  bsSecondaryVariant: 'light',
  socialIconBgColor: '#fefefe',
};
